<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">자료실 상세</h2>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="write">
              <colgroup>
                <col width="200">
                <col width="*">
              </colgroup>
              <tbody>
                <tr>
                  <th><span>제목</span></th>
                  <td>{{resourcesInfo.title}}</td>
                </tr>
                <tr>
                  <th><span>작성일자</span></th>
                  <td>{{resourcesInfo.reg_dt}}</td>
                </tr>
                <tr>
                  <th><span>노출여부</span></th>
                  <td>
                      <div class="form_inline">
                        <div class="form_radio">
                          <input type="radio" id="dtlExposureY" name="dtlExposureYn" value="Y" :checked="resourcesInfo.display_yn == 'Y'" disabled>
                          <label for="dtlExposureY">노출</label>
                        </div>
                        <div class="form_radio">
                          <input type="radio" id="dtlExposureN" name="dtlExposureYn" value="N" :checked="resourcesInfo.display_yn != 'Y'" disabled>
                          <label for="dtlExposureN">미노출</label>
                        </div>
                      </div>
                  </td>
                </tr>
                <tr>
                  <th><span>내용</span></th>
                  <td>
                      <div v-html="resourcesInfo.content">
                      </div>
                  </td>
                </tr>
                <tr>
                  <th><span>첨부파일</span></th>
                  <td>
                    <div class="form_inline" v-if="resourcesInfo.file_org_name != null && resourcesInfo.file_org_name != ''">
                      <ul class="file_list">
                        <li><a href="#" @click.prevent="fn_download_file(resourcesInfo.file_id)">{{resourcesInfo.file_org_name}}</a></li>
                      </ul>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="bottom_box">
              <button class="btn btn_md btn_outline" @click="fn_move_list_page">목록</button>
              <div class="btn_box">
                <button class="btn btn_md btn_gray" @click="fn_del_resources">삭제</button>
                <button class="btn btn_md btn_darkblue" @click="fn_update_resources">수정</button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
</template>

<script>
  import axios from 'axios'
  import commonUtil from "@/mixin/commonUtil";

  export default {
    name: 'ResourcesMngtDtl',
    mixins: [commonUtil],
    data() {
      return {
        resourceId: '',
        resourcesInfo : {}
      }
    },
    created(){
      this.resourceId = this.$store.getters['resources/getResourceId'];
      console.log("@@@@ resourceId : "+this.resourceId);
      this.fn_search(this.resourceId);
    },
    methods : {
        fn_search(resourceId){

            let param = new Object();
            param.resourceId = resourceId;

            console.log("@@@@ param : %o",param);

            axios
                .post("/api/admin/board/resourcesDetail", param)
                .then((res) => {
                    console.log("@@@@ res : %o",res);
                    this.resourcesInfo = res.data;

                    console.log("@@@@ resourcesInfo : %o",this.resourcesInfo);
                })
                .catch((err) => console.log(err));

        },
        fn_move_list_page(){
            this.$store.dispatch('resources/setResourceId', '');
            this.$router.push("/admin/board/resourcesMngt");
        },
        fn_del_resources(){
            let param = new Object();
            param.resourceId = this.resourceId;

            axios
                .post("/api/admin/board/deleteResources", param)
                .then((res) => {
                    alert("삭제되었습니다");
                    this.fn_move_list_page();
                })
                .catch((err) => console.log(err));
        },
        fn_update_resources(){
            this.$store.dispatch('resources/setResourceId', this.resourceId);
            this.$router.push("/admin/board/resourcesMngtReg");
        },
    }
  }
</script>

<style scoped>
.table_list table.write {
  table-layout: fixed;
  width: 100%;
}

.table_list table.write th {
  width: 200px;
  min-width: 200px;
  max-width: 200px;
  overflow: hidden;
}

.table_list table.write td {
  overflow: hidden;
  word-break: break-word;
}

.table_list table.write td > div {
  max-width: 100%;
  overflow: hidden;
}

.table_list table.write td >>> img {
  max-width: 100%;
  height: auto;
}
</style>